import PropTypes from 'prop-types';
import './styles/menuStyles.css';

// This component is deprecated in favor of <MenuButton /> from the __pds folder
const MenuHeading = ({ children }) => {
  return (
    <div className="border-b border-t border-solid border-gray-2 first:border-t-0 first:-mt-2">
      <p className="font-semibold m-0 py-2 px-4 uppercase">{children}</p>
    </div>
  );
};

MenuHeading.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MenuHeading;
